import React, { useContext, useEffect, useState } from 'react'
import './statistiquesAujourdhui.css'
import Label from '../../../svg/Label'
import { StatistiqueContext } from '../../../context/statistiqueContext/StatistiqueContext';
import ErrorComponent from '../../../components/errorComponent/ErrorComponent';
import LoadingComponent from '../../../components/loadingComponent/LoadingComponent';
import { getStatistiques } from '../../../context/statistiqueContext/apiCalls'

function StatistiquesAujourdhui() {
    const { dispatch, statistiques, isFetchingGet, errorGet } = useContext(StatistiqueContext);

    useEffect(() => {
        getStatistiques(dispatch);
    }, [])

    return (
        <div className='statistiques'>
            {
                errorGet ? <ErrorComponent error={errorGet} /> : (
                    isFetchingGet ? <LoadingComponent /> : (
                        <>
                            {/* Nombre d'Envois Par Action */}
                            <div className='statistiques-title'>
                                <Label widthSize="35px" heightSize='17px' />
                                <span>Nombre d'Envois :</span>
                            </div>
                            <div className='statistiques-boxes'>
                                <div className='statistiques-box'>
                                    <span className="statistiques-sub-title depot-agence">Aujourdui'hui</span>
                                    <div className="statistiques-sub-detail">
                                        <div>
                                            <span>
                                                {
                                                    statistiques["historyActionD"] ? statistiques["historyActionD"] : 0
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='statistiques-box'>
                                    <span className="statistiques-sub-title acheminement-depart">Mois En Cours</span>
                                    <div className="statistiques-sub-detail">
                                        <div>
                                            <span>
                                                {
                                                    statistiques["historyActionM"] ? statistiques["historyActionM"] : 0
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className='statistiques-box'>
                                    <span className="statistiques-sub-title livraison-agence">Global</span>
                                    <div className="statistiques-sub-detail">
                                        <div>
                                            <span>
                                                {
                                                    statistiques["historyActionG"] ? statistiques["historyActionG"] : 0
                                                }
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </>
                    )
                )
            }
        </div >
    )
}

export default StatistiquesAujourdhui